import React, { useRef } from 'react';
import './Regions.css';

// Import icons and the new map images
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import indiaMap from '../../assets/images/region-india.png';
import bangladeshMap from '../../assets/images/region-bangladesh.png';
import argentinaMap from '../../assets/images/region-argentina.png';
import australiaMap from '../../assets/images/region-australia.png';

const regionsData = [
  { name: 'India', image: indiaMap },
  { name: 'Bangladesh', image: bangladeshMap },
  { name: 'Argentina', image: argentinaMap },
  { name: 'Australia', image: australiaMap },
  // Add more regions here as you get images
];

const Regions = () => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="regions-section">
      <div className="regions-container">
        <div className="section-header">
          <h2>What's happening in different regions</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          CRISHI gives you region-wise market updates, so you're never out of touch with the global picture.
        </p>

        <div className="regions-carousel-container">
          <button className="scroll-arrow left" onClick={() => scroll('left')}><FiArrowLeft /></button>
          <div className="regions-scroller" ref={scrollContainerRef}>
            {regionsData.map((region, index) => (
              <div key={index} className="region-card">
                <div className="region-card-image">
                  <img src={region.image} alt={`Map of ${region.name}`} />
                </div>
                <p className="region-card-name">{region.name}</p>
              </div>
            ))}
          </div>
          <button className="scroll-arrow right" onClick={() => scroll('right')}><FiArrowRight /></button>
        </div>
      </div>
    </section>
  );
};

export default Regions;